<form [formGroup]="formApplication" class="new-app-container">
  <div class="basic-field-group">
    <div class="basic-field-group-item--max-width">
      <div class="label-data label">
        <div class="label">Name</div>
      </div>
      <div class="basic-field-group__input">
        <input
          autocomplete="off"
          class="text-input"
          placeholder="Enter application name"
          name="name"
          formControlName="name"
          [ngClass]="{ 'disable-Input': inputDisable }"
          maxlength="30"
          required
        />

        <div
          class="error"
          *ngIf="
            formApplication.get('name').invalid &&
            (formApplication.get('name').dirty || formApplication.get('name').touched)
          "
        >
          <mat-error *ngIf="formApplication.get('name').errors.required"
            >Name is required.</mat-error
          >
          <mat-error *ngIf="formApplication.get('name').errors.isUnique"
            >Name already exist.</mat-error
          >
        </div>
      </div>
    </div>
  </div>
  <mat-slide-toggle
    [(ngModel)]="isChecked"
    [ngModelOptions]="{ standalone: true }"
    [disabled]="formApplication.disabled"
    [checked]="isChecked"
    (change)="resetURLvalues()"
    color="primary"
  >
    <div class="label-data label">
      <div class="label">URL with Auth</div>
    </div>
  </mat-slide-toggle>

  <div class="basic-field-group" *ngIf="!isChecked">
    <div class="basic-field-group-item">
      <div class="label-data label">
        <div class="label">URL</div>
      </div>
      <div class="basic-field-group__input">
        <input
          autocomplete="off"
          class="text-input"
          placeholder="Enter application URL"
          formControlName="url"
          name="url"
          [ngClass]="{ 'disable-Input': inputDisable }"
          type="url"
        />
        <div
          class="error"
          *ngIf="
            formApplication.get('url').invalid &&
            (formApplication.get('url').dirty || formApplication.get('url').touched)
          "
        >
          <mat-error *ngIf="formApplication.get('url').errors.required">Url is required.</mat-error>
          <mat-error *ngIf="formApplication.get('url').errors.isUnique"
            >Url already exist.</mat-error
          >
        </div>
        <div class="error" *ngIf="formApplication.get('url').valid && !isValidUrl">
          <mat-error>{{ urlValidationWarningMessage }}</mat-error>
        </div>
      </div>
    </div>
  </div>
  <div class="basic-field-group" *ngIf="isChecked">
    <div class="basic-field-group-item">
      <div class="label-data label">
        <div class="label">URL with Auth</div>
      </div>
      <div class="basic-field-group__input">
        <textarea
          autocomplete="off"
          class="text-input"
          placeholder="Enter the URL with auth"
          formControlName="curlUrl"
          name="curlUrl"
          type="textArea"
          rows="20"
          [ngClass]="{ 'disable-Input': inputDisable }"
          cols="50"
          required
        >
        </textarea>
      </div>
    </div>
  </div>

  <div class="new-application">
    <button
      mat-flat-button
      color="primary"
      [disabled]="newAppButtonEnable()"
      (click)="createNewApplication()"
    >
      Create new application
    </button>
    <button mat-button class="btn-close" color="primary" (click)="close()">Close</button>
  </div>
</form>
